export enum OptionalColumnType {
    ACTUAL,
    TARGET,
    PERCENT_TO_TARGET,
    WEIGHT,
    ORIGINAL_POINTS,
    ADJUSTED_POINTS,
    METRIC_SCORE,
    METRIC_RANK,
    POINTS_BAND,
    N_TILE,
    N_TILE_BAND,
    ACTUAL_TYPE,
    TARGET_TYPE,
    PERCENT_TYPE,
    SCORING_TYPE,
    ACTUAL_TREND,
    PERCENT_TO_TARGET_TREND,
    COACHING_PLAN_ACTIVE,
    METRIC_LABEL,
    USER_NAME,
    SUPERGROUP_NAME,
}

export interface OptionalColumn {
    columnType: OptionalColumnType;
    displayOrder: number;
}

export interface PillarMetric {
    metricId: number;
    metricName?: string;
    displayOrder: number;
    weight: number;
    displayType?: number; // TODO enum
    optionalColumns?: OptionalColumn[];
    components?: PillarMetric[];
}

export interface Pillar {
    identifier: string;
    name: string;
    shortName?: string;
    initials?: string;
    clientLanguageTranslationId?: number;
    description?: string;
    descriptionClientLanguageTranslationId?: number;
    displayOrder: number;
    metrics?: PillarMetric[];
}

export interface Message {
    attributeName: string;
    name: string;
    processOrder: number;
    attributeValues: AttributeValue[];
}

export interface AttributeValue {
    attributeValue: string;
    attributeValueId: number;
    defaultMessageText: string;
    displayType: string;
    textId: number;
}

/// ///////

export interface ColourPoolItem {
    colour: string;
    highContrastColour?: string;
    useOrder: number;
}

export interface BaseWidget {
    name: string;
    shortName: string;
    initials: string;
    clientLanguageTranslationId?: number;
    enabled: boolean;
    containerColour: string;
    highContrastContainerColour: string;
    headerColour: string;
    highContrastHeaderColour: string;
    headerTextColour: string;
    highContrastHeaderTextColour: string;
    textColour: string;
    highContrastTextColour: string;
    backgroundColour: string;
    highContrastBackgroundColour: string;
    displayOrder: number;
}

interface ScorecardTrendChart extends BaseWidget {
    defaultView?: string;
    colourPool?: ColourPoolItem[];
    superGroupColourPool?: ColourPoolItem[];
    rankColourPool?: ColourPoolItem[];
    collapsed?: boolean;
}

interface ScorecardDetail extends BaseWidget {
    collapsed?: boolean;
}

interface ScorecardDetail extends BaseWidget {
    collapsed?: boolean;
}

export interface RootDefinition {
    identifier: string;
    scorecardTrendChart: ScorecardTrendChart;
    scorecardDetail: ScorecardDetail;
}
